import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {
  ClientsContract,
  ClientsContractsFilters,
  ClientsContractUI
} from '@store/clients/contracts/clients-contracts.model';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface ClientsContractsState {
  filters: ClientsContractsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const clientsContractsStore = createStore(
  {name: 'clients-contracts'},
  withProps<ClientsContractsState>({
    filters: {search: '', tableFilters: ClientsContractsFilters.initTableFilters(), filterExpiredContracts: true},
    sort: {
      field: 'contract.contractReference',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<ClientsContract>(),
  withUIEntities<ClientsContractUI>(),
  withPagination(),
  withRequestsStatus(),
);
